import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { bidderGuard } from './core/guards/bidder.guard';
import { loginGuard } from './core/guards/login.guard';
import { developerGuard } from './core/guards/developer.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/pages/login/login.component').then((m) => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'register/:token',
    loadComponent: () =>
      import('./features/auth/pages/register/register.component').then((m) => m.RegisterComponent),
    canActivate: [],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./features/auth/pages/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },

  // Main layout with nested routes
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    canActivate: [authGuard],
    children: [
      // Shared routes (accessible by both admin and bidder)
      {
        path: 'profile',
        loadComponent: () =>
          import('./shared/pages/profile/profile.component').then((m) => m.ProfileComponent),
      },

      // Admin routes
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/admin/pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'bidders',
        loadComponent: () =>
          import('./features/admin/pages/bidders/bidders.component').then(
            (m) => m.BiddersComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'bidders/:id',
        loadComponent: () =>
          import('./features/admin/pages/bidders/bidder-details/bidder-details.component').then(
            (m) => m.BidderDetailsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'rfps',
        loadComponent: () =>
          import('./features/admin/pages/rfps/rfps.component').then((m) => m.RfpsComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'rfps/:id',
        loadComponent: () =>
          import('./features/admin/pages/rfps/rfp-details/rfp-details.component').then(
            (m) => m.RfpDetailsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'clients',
        loadComponent: () =>
          import('./features/admin/pages/clients/clients.component').then(
            (m) => m.ClientsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'clients/:id',
        loadComponent: () =>
          import('./features/admin/pages/clients/client-details/client-details.component').then(
            (m) => m.ClientDetailsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./features/admin/pages/projects/projects.component').then(
            (m) => m.ProjectsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./features/admin/pages/projects/project-details/project-details.component').then(
            (m) => m.ProjectDetailsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'invitations',
        loadComponent: () =>
          import('./features/admin/pages/invitations/invitations.component').then(
            (m) => m.InvitationsComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'faq-management',
        loadComponent: () =>
          import('./features/admin/pages/faq-management/faq-management.component').then(
            (m) => m.FaqManagementComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'playground',
        loadComponent: () =>
          import('./features/admin/pages/playground/playground.component').then(
            (m) => m.PlaygroundComponent
          ),
        canActivate: [adminGuard, developerGuard],
      },

      // Bidder routes
      {
        path: 'bid-sheets',
        loadComponent: () =>
          import('./features/bidder/pages/bid-sheets/bid-sheets.component').then(
            (m) => m.BidSheetsComponent
          ),
        canActivate: [bidderGuard],
      },
      {
        path: 'faq',
        loadComponent: () =>
          import('./features/bidder/pages/faq/faq.component').then((m) => m.FaqComponent),
        canActivate: [bidderGuard],
      },
      {
        path: 'bid-sheets/:id',
        loadComponent: () =>
          import('./features/bidder/pages/bid-sheet-detail/bid-sheet-detail.component').then(
            (m) => m.BidSheetDetailComponent
          ),
        canActivate: [bidderGuard],
      },
    ],
  },
];
